<form #accountsettingsform="ngForm" name="accountsettingsform" (ngSubmit)="onSubmit()" class="mb-0">

  <div *ngIf="regionId === 1">
    <div class="fieldset fieldset--lg" style="margin-bottom: 15px;">
      <p class="form-info-p">All fees you collect will be settled to the account you specify below</p>
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="bankId">Select Your Bank</label>
      <ng-select aria-required="true" [(ngModel)]="schooInfo.bankId" name="bankId" id="bankId" ngDefaultControl
        #bankIdField>
        <ng-option *ngFor="let bank of banks" [value]="bank.id">{{bank.name}}</ng-option>
      </ng-select>
    </div>
    <div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
      <div class="fieldset fieldset--lg flex-fill mr-md-3">
        <label class="legend" for="accountName">Account Name</label>
        <input type="text" [(ngModel)]="schooInfo.accountName" #accountName required name="accountName"
          class="text-field" id="accountName">
      </div>
      <div class="fieldset fieldset--lg flex-fill">
        <label class="legend" for="accountNumber">Account Number</label>
        <input type="text" [(ngModel)]="schooInfo.accountNumber" #accountNumber required name="accountNumber"
          class="text-field" id="accountNumber">
      </div>
    </div>
  </div>
  <div *ngIf="regionId !== 1">
    <div class="card mt-3" *ngIf="regionId !== 1">
      <div class="card-header text-center">
        <h4 class="display-5">Payout Setup</h4>
      </div>
  
      <div class="card-body">
        <p class="mb-0 small text-muted">
          All payment processing, payouts, fees, dispute management, and account administration are handled directly by Stripe. Full access to the Stripe Dashboard is provided, enabling complete control over the Stripe account and all associated payment operations.
        </p>
      </div>
    </div>
    <div class="fieldset fieldset--lg" style="margin-bottom: 15px;">
      <p class="form-info-p">Email address will be used to create your payout account on stripe</p>
    </div>
    <div class="fieldset--lg d-flex flex-column flex-md-row m-auto mw-100">
      <div class="fieldset fieldset--lg flex-fill mr-md-3">
        <label class="legend" for="accountName">Account Email</label>
        <input type="email" [(ngModel)]="stripeEmail" required name="email" class="text-field" id="stripeemail">
      </div>
      <div>
        <label>Are you registering with a personal account? </label>
        <input type="checkbox" [(ngModel)]="isIndividualAccount" name="individualAccount" id="individualAccount">
      </div>
    </div>
  
  
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5 mt-5">
    <button class="btn m-0" [disabled]="this.accountsettingsform.invalid || isSubmitting" type="submit">Save</button>
    <button class="btn btn--warning m-0" routerLink="/account/accountsettings">Cancel</button>
  </div>
</form>
